<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ul class="how">
          <li class="how__item">
            <div class="how__inner">
              <div class="how__img-container">
                <img src="/images/Delivery.webp" alt="" class="how__img" loading="lazy" width="88" height="88" />
              </div>
              <div class="how__text-container">
                <h4>Fast delivery</h4>
                <p class="how__text m-0 p-0">Your SIM will be with you in 1 - 3 days</p>
              </div>
            </div>
          </li>
          <li class="how__item">
            <div class="how__inner">
              <div class="how__img-container">
                <img src="/images/Sim Cardy.webp" alt="" class="how__img" loading="lazy" width="88" height="88" />
              </div>
              <div class="how__text-container">
                <h4>Simple activation</h4>
                <p class="how__text m-0 p-0">Activate your SIM <a href="https://dev-portal.grapefroot.co.uk/">here</a></p>
              </div>
            </div>
          </li>
          <li class="how__item">
            <div class="how__inner">
              <div class="how__img-container">
                <img src="/images/Mobile Number.webp" alt="" class="how__img" loading="lazy" width="88" height="88" />
              </div>
              <div class="how__text-container">
                <h4>Keep your number</h4>
                <p class="how__text m-0 p-0">Easily teansfer your number (optional)</p>
              </div>
            </div>
          </li>
          <li class="how__item">
            <div class="how__inner">
              <div class="how__img-container">
                <img src="/images/Rewards.webp" alt="" class="how__img" loading="lazy" width="88" height="88" />
              </div>
              <div class="how__text-container">
                <h4>Deals & offers</h4>
                <p class="how__text m-0 p-0">Take advantage of your Grapefroot benefits</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h4 {
  color: var(--lime);
  font-size: 1.3em;
}
.how {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  filter: drop-shadow(var(--box-shadow));

  @media only screen and (min-width: 992px) {
    flex-direction: row;
  }

  &__item {
    margin: 0 0 3em;
    position: relative;

    @media only screen and (min-width: 992px) {
      width: 25%;

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        top: 60%;
        left: 100%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 20px solid var(--black);
      }
    }
  }

  &__inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: 992px) {
      flex-direction: column;
      text-align: center;
    }
  }
  &__text-container {
    width: 70%;
  }
  &__text {
    color: var(--primary);
  }
  &__img-container {
    width: 30%;
    position: relative;
    display: flex;
    justify-content: center;

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-top: 15px solid var(--black);

      @media only screen and (min-width: 992px) {
        content: unset;
        border: unset;
      }
    }
  }
  &__img {
    width: 90px;
    background: var(--black);
    border-radius: 50px;
    padding: 5px;
    @media only screen and (min-width: 992px) {
      margin-bottom: 20px;
    }
  }

  li.how__item:last-child .how__img-container::after {
    content: unset;
    border: unset;
  }
}
</style>
